export function isTruthy(value: string | number | boolean | undefined): boolean | undefined {
	if (value === undefined) return;

	const truthyValues = ['tak', 'áno', 'ja', 'ano'];
	const falsyValues = ['nie', 'ne', 'žádný', 'nein'];

	const stringValue = value.toString().toLocaleLowerCase();

	if (truthyValues.includes(stringValue)) {
		return true;
	} else if (falsyValues.includes(stringValue)) {
		return false;
	} else {
		return;
	}
}
